/**
 * 配置信息
 */
const host = location.host
const isDevHost = /dev|localhost|(\d+\.\d+\.\d+\.\d+)/.test(host)
export const LOCAL_API_LOGOUT_URL = (() => {
  if (isDevHost) {
    if (host === 'zujuan-dev.wln100.com') {
      return '//ua-dev.tesoon.com/'
    } else {
      return '/'
    }
  } else {
    return '//useradmin.tesoon.com/'
  }
})()

export const LOCAL_API_URL = (() => {
  if (isDevHost) {
    if (host === 'zujuan-dev.wln100.com') {
      return '//zjapi-dev.wln100.com/'
    } else {
      return '/'
    }
  } else {
    return '//api.wln100.com/'
  }
})()

export const LOCAL_API_URL_V2 = (() => {
  if (isDevHost) {
    if (host === 'zujuan-dev.wln100.com') {
      return '//wwwapi-dev.wln100.com/'
    } else {
      return '/'
    }
  } else {
    return '//kszxapi.wln100.com/'
  }
})()

const PROD_ENV = process.env.NODE_ENV === 'production'

// api 地址
export const API_URL = PROD_ENV ? LOCAL_API_URL : '/api/'
export const API_URL_V2 = PROD_ENV ? LOCAL_API_URL_V2 : '/api/'
export const API_LOGOUT_URL = PROD_ENV ? LOCAL_API_LOGOUT_URL : '/sso_api/'
export const IMAGE_URL = '' // 图片资源地址
export const NOTICE_DURATION = 2500 // 顶部通知提示时间
export const AXIOS_TIMEOUT = 30000 // 请求超时时间
export const ONLINE_UPLOAD_URL = '' // 文件上传地址
export const ACCESS_TOKEN_KEY = 'access-token'
export const USER_ACCOUNT_KEY = 'user_account'
export const SAVE_ACCOUNT_ACTIVE_KEY = 'save_account_active'
export const QUES_BASKET_KEY = 'wln_ques_basket' // 试题篮
export const PAPER_CFG = 'wln_paper_cfg' // 试卷配置
export const PAPER_RECYCLE = 'wln_paper_recycle' // 回收站
export const CURRENT_SUBJECT = 'wln_current_subject' // 当前学科

export const DEFAULT_USER_PHOTO = require('../assets/default/default_head_img.png')

export const APPLICATION_ID = 'txc74d97b01e' // 应用唯一id
export const LOGIN_URL = isDevHost ? '//u-dev.tesoon.com/' : '//user.tesoon.com/' // 登录地址
export const REGISTER_URL = isDevHost ? '//u-dev.tesoon.com/register' : '//user.tesoon.com/register' // 注册地址

export const LOADING_CONFIG = {
  lock: false,
  text: '数据加载中，请稍候...',
  spinner: 'el-icon-loading',
  background: 'rgba(255, 255, 255, 0.60)'
}
